import { createContext } from "react";

import { IContextWs } from "./ws.types";

export const ContextWs = createContext<IContextWs>(
  null as unknown as IContextWs,
);
